import styled from "styled-components";
import { breakpoints } from "styles";

export const NpsThankyouScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
  margin-top: 18px;
`;

export const CocoImageContainer = styled.div<{ isSkipConfirmation: boolean }>`
  width: ${({ isSkipConfirmation }) =>
    isSkipConfirmation ? "144px" : "224px"};
  height: ${({ isSkipConfirmation }) =>
    isSkipConfirmation ? "144px" : "224px"};
`;

export const ThankyouScreenHeading = styled.h1`
  width: 425px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  text-align: center;
  margin-top: 30px;
  color: ${({ theme }) => theme.colors.neutral["900"]};
  line-height: 24px;
  margin-bottom: 0;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
    line-height: 40px;
  }
`;

export const ThankyouScreenSubheading = styled.p`
  width: 300px;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  margin: 12px 0 24px 0;
  color: ${({ theme }) => theme.colors.neutral["900"]};

  @media ${breakpoints.laptop} {
    width: 425px;
    font-size: ${({ theme }) => theme.fontSizes["lg"]};
  }
`;

export const ThakyouScreenStyledButtonContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;

  @media ${breakpoints.laptop} {
    width: 260px;
    margin-bottom: 24px;
  }
`;

export const SeeYouLaterCTA = styled.button`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.brand["500"]};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  background: none;
  border: none;
  font-weight: bold;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  cursor: pointer;

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["md"]};
    margin-top: 0;
  }
`;
